<script setup>
/**
 * FormControlCategoriesComponentMenu
 * A specialized select menu that filters system components
 * to display only those relevant to category structures.
 * Only used by templates of the "Categories" contentType.
 */
import {computed, onMounted} from 'vue'
import {useComponentsStore} from '@/stores/components'
import FormControlTypeSelect from '@/common/form-control-type/FormControlTypeSelect.vue'

const props = defineProps({
    // Standard Orchestrator Props
    formId: {
        type: String,
        required: true
    },
    field: {
        type: Object,
        required: true
    },
    currentData: {
        type: Object,
        required: true
    },
    value: {
        type: [String, Number],
        default: null
    }
})

// Pinia Stores
const componentsStore = useComponentsStore()

// --- Computed ---

/**
 * Filter the store's component items:
 * 1. Must be a category component (> 0)
 * 2. Must have a category list defined
 * 3. Map to standard value/text objects for the select component
 * 4. Sort alphabetically by title
 */
const options = computed(() => {
    return (componentsStore.items || [])
        .filter(o => o.categoryComponent > 0 && o.categoryList)
        .map(o => ({
            value: o.id,
            text: o.title
        }))
        .sort((a, b) => (a.text > b.text ? 1 : -1))
})

// --- Lifecycle ---

onMounted(() => {
    // Ensure the field is marked as required for validation
    props.field.required = true
})
</script>

<template>
    <FormControlTypeSelect v-bind="$props" :options="options"/>
</template>